/** Checklist section labels and display order (Lista tab). */
export const CHECKLIST_CATEGORY_LABELS = {
  prenotazioni: 'Prenotazioni',
  documenti: 'Documenti',
  auto: 'Auto e strada',
  app: 'App da installare',
  viaggio: 'Viaggio in auto',
  dispensa: 'Spesa e dispensa',
  valigia: 'Valigia comune',
  zaino: 'Zaino giornaliero',
  'settimana-1': 'Settimana 1 · Montagna e laghi',
  'settimana-2': 'Settimana 2 · Lubiana e dintorni',
  drone: 'Oggetti e Tech',
  'giorno-prima': 'Il giorno prima',
  altro: 'Altro',
};

export const CHECKLIST_CATEGORY_ORDER = [
  'prenotazioni',
  'documenti',
  'auto',
  'app',
  'viaggio',
  'dispensa',
  'valigia',
  'zaino',
  'settimana-1',
  'settimana-2',
  'drone',
  'giorno-prima',
  'altro',
];

export function checklistCategoryLabel(category) {
  return CHECKLIST_CATEGORY_LABELS[category] ?? category;
}
